/*
 *  Newsletter Pop-up
 *    Provides scripts for the newsletter pop-up
 *
 *  Version:
 *    1.0.0 - 2019/07/04
 */

import $ from 'jquery';
import Cookies from 'js-cookie';
import { register, ShopifySection } from './../../sections/ShopifySection';
import { fetchGeo, onGeoFetch, addInternationalMsgClass, GEO_CACHE_COOKIE } from './../../tools/Geo';

export const CONTAINER_SELECTOR = '[data-international-message-popup]';
export const CLOSE_SELECTOR = '[data-international-message-popup-close]';
export const MESSAGE_BTN = '[data-international-message-popup-btn]';
export const MESSAGE_UNDERLAY = '[data-international-message-popup-underlay]';
export const MESSAGE_CONTENT = '[data-international-message-popup-content]';
export const MESSAGE_SUBMIT = '[data-newsletter-submit]';
export const MESSAGE_DESKTOP = '[data-international-message-popup-desktop]';
export const MESSAGE_MOBILE = '[data-international-message-popup-mobile]';

export const MESSAGE_CART_TITLE = '[data-international-message-cart-title]';

export const POPUP_COOKIE = 'hide-popup';
export const CLASS_POPUP_OPEN = 'is-int-msg-popup-open';
export const CLASS_CHECKOUT_POPUP_ACTIVE = 'is-checkout-message-active';

export const CART_TEMPLATE_CHECKOUT = '[data-cart-body-checkout]';
export const CART_MESSAGE_SELECTOR = '[data-international-message-title]';
export const CART_MESSAGE_SIZE = '[data-international-message-cart-size]';


export class InternationalMessagePopup extends ShopifySection {
  constructor(container) {
    super(container);
    this.container = container;
    this.popupUnderlay = container.find(MESSAGE_UNDERLAY);
    this.popupTargets = [container,this.popupUnderlay,$('html,body')];
    this.messageContents = container.find(MESSAGE_CONTENT);
    this.messageDesktop = container.find(MESSAGE_DESKTOP);
    this.messageCartTitle = container.find(MESSAGE_DESKTOP);
    this.messageCartSize = container.find(CART_MESSAGE_SIZE);


    container.on('click touch', CLOSE_SELECTOR, e => this.onCloseClick(e));
    container.on('click touch', MESSAGE_UNDERLAY, e => this.closeMessagePopup(e));
    container.on('click touch', MESSAGE_BTN, e => this.toggleMessage(e));
    $(document).on('click touchend', CART_TEMPLATE_CHECKOUT, e => this.onInternationalPopup(e));


    let geoData;
    try {
       if (Cookies.get(GEO_CACHE_COOKIE)){
        geoData = JSON.parse(Cookies.get(GEO_CACHE_COOKIE));
       }   
    } catch (error) {
      console.log(error)
    }
    let title = this.container.find(MESSAGE_CART_TITLE).text();
    if (geoData){
      if (geoData.country_code) {
        title = title.replace(/%country%/g, geoData.country_code.toUpperCase());
      } else {
        title = title.replace(/%country%/g, 'other country');
      }
      this.container.find(MESSAGE_CART_TITLE).text(title);
    }

    //generate mobile table
    [...this.messageDesktop].forEach(element => {
      let mobileTable = $(element).closest(MESSAGE_CONTENT).find(MESSAGE_MOBILE);
      if(mobileTable) $(mobileTable).html(this.generateMobileTable(element));      
    });

  }

  onCloseClick(e) {
   
    if ($(e.currentTarget).attr('href')) {
      if ($(e.currentTarget).attr('href') === '#') {
        this.cancelEvent(e);
        this.closeMessagePopup();
      } else {
        return;
      }
    }

    this.cancelEvent(e);
    this.closeMessagePopup();
  }

  closeMessagePopup() {
    this.popupTargets.forEach(e => e.removeClass(CLASS_POPUP_OPEN));
  }

  openMessagePopup() {
    this.popupTargets.forEach(e => e.addClass(CLASS_POPUP_OPEN));
  }

  cancelEvent(e) {
    e.preventDefault(), e.stopPropagation();
    return true;
  }

  onClickOutside(e) {
    if(!this.container.hasClass(CLASS_POPUP_OPEN)) return; //Not visible?
    let check = this.container.find(e.target);
    if(check.length) return;
    this.cancelEvent(e);
    this.closeMessagePopup();
  }

  toggleMessage(e) {
    let id = $(e.currentTarget).attr('data-index');
    if (!this.messageContents) return;
    [...this.messageContents].forEach(e => {
      if ($(e).attr('data-index') === id ) {
        this.messageContents.removeClass('is-active');
        $(e).addClass('is-active');
        return;
      }
      // return;
    });
  }

  generateMobileTable(element) {
    let titles = [], sizes = [], dimensions = [];
    $(element).find('thead th').filter(function() {
      let title = $(this).text().trim();
      if (title && title != '') {
        titles.push(title);
      }
    });
    $(element).find('tbody tr td:first-child').each(function() {
      let size = this.innerText;
      sizes.push(size);
      let d = $(this).parent('tr').find('td:not(:first-child)');
      d.each(function() {
        dimensions.push(this.innerText);
      });
    });
    return this.generateHTML(titles,sizes,dimensions);

  }

  onGeoFetch(data) {
    if(Cookies && Cookies.get(GEO_CACHE_COOKIE)) this.checkGeo();
  }

  generateHTML(titles,sizes,dimensions) {
    let html = '';

    let dIndex = 0;
    for (let i = 0; i < sizes.length; i++) {
      let data = `<div class="c-international-message-popup__table-size"> ${sizes[i]} </div>`;
      for (let j = 0; j < titles.length; j++) {
        data = data + 
        `<div class="c-international-message-popup__table-data"> 
          <span class="c-international-message-popup__table-title">${titles[j]}: </span> 
          <span class="c-international-message-popup__table-dimension">${dimensions[dIndex]}</span>
          </div>`;
        dIndex ++;
      }
      html = `<div class="c-international-message-popup__table-wrapper">${data}</div> ${html}` ;
    }

    return html;

  }

  onInternationalPopup(e) {
    if (!this.container.hasClass(CLASS_CHECKOUT_POPUP_ACTIVE)) return;
    // if ($(document).find(CART_MESSAGE_SELECTOR).length < 1) return;
    let geoData = JSON.parse(Cookies.get(GEO_CACHE_COOKIE));
    if (!geoData) return;
    let geoCountry = geoData.country_code;
    if(geoCountry.toLowerCase() == 'au' || !geoCountry) return;

    e.preventDefault(), e.stopPropagation();
    let title = this.container.find(MESSAGE_CART_TITLE).text();
    //display bedding size based on location
    this.messageCartSize.addClass(geoCountry.toLowerCase());

    if (geoCountry) {
      title = title.replace(/%country%/g, geoCountry.toUpperCase());
    } else {
      title = title.replace(/%country%/g, 'other country');
    }
    this.container.find(MESSAGE_CART_TITLE).text(title);

    $(MESSAGE_CONTENT).hide();
    $('.c-international-message-popup__size-btns').hide();
    $('.c-international-message-popup__cart').show();
    
    this.openMessagePopup();
  }

  // checksize() {
  //   if (window.location.href.indexOf("cart") == -1) return;
  //   let hasSize = false;
  //   let substringsArray = ['single','double','queen','king','super king'];
  //   let cart = getCurrentCart();
  //   let product = cart.items;
  //   product.forEach(p => {
  //     substringsArray.some(substring => {
  //       Object.values(p.options_with_values).some(s => {
  //         let value = s.value.toLowerCase();
  //         if (value.includes(substring)) { 
  //           hasSize = true;
  //           return;
  //         }
  //      });
  //     })
  //   });
  //   return hasSize;
  // }

}

register(CONTAINER_SELECTOR, InternationalMessagePopup);